module.exports = __webpack_public_path__ + "img/vertical_6_7_7042.0fa3395e.png";